// extracted by mini-css-extract-plugin
export default {"cta":"hI-z","disabled":"iI-z"};